import { AuthContext } from 'constants/contexts';
import { updateUrlParameter } from 'utils/url';
import axios from 'axios';
import ConfigProvider from 'components/ConfigProvider';
import { apiUrl, env } from '../constants';

export function httpServiceFactory({ baseUrl, getAuthorizationFn, getUrlParamsFn }) {
  const axiosInstance = axios.create({
    baseURL: baseUrl,
  });
  axiosInstance.interceptors.request.use((config) => {
    if (getAuthorizationFn && config.headers.Authorization == null) {
      config.headers = {
        ...config.headers,
        Authorization: getAuthorizationFn(),
      };
    }
    if (getUrlParamsFn) {
      const params = getUrlParamsFn();
      config.url = Object.entries(params).reduce((url, [key, value]) => url.replace(`{{${key}}}`, value), config.url);
    }
    return config;
  }, (error) => Promise.reject(error));
  return axiosInstance;
}

const http = httpServiceFactory({
  baseUrl: apiUrl,
  getAuthorizationFn: () => {
    const user = AuthContext.getUser();
    return user?.token && user?.tokenVerified ? user.token : null;
  },
  getUrlParamsFn: () => ({ organizationId: ConfigProvider.ORG_ID }),
});

// Todo be able to update it at runtime
if (env.LANG) {
  http.interceptors.request.use(
    (request) => {
      request.url = updateUrlParameter({
        url: request.url,
        key: 'lang',
        value: env.LANG,
      });
      return request;
    },
    (error) => Promise.reject(error),
  );
}

export const defaultFetcher = (...args) => http.get(...args).then((res) => res.data);
export const mockFetcher = (...args) => new Promise((resolve) => { setTimeout(() => resolve(...args), 5000); });

export default http;
